import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import React from 'react';
import MobileDevPageDisplaySide300x250Gak from './gak/MobileDevPageDisplaySide300x250';
import MobileDevPageDisplaySide300x250Nitro from './nitro/MobileDevPageDisplaySide300x250';
const MobileDevPageDisplaySide300x250 = ({ safety ='off'  })=>{
    const isDaAds = useFlag('ads_da');
    if (isDaAds) {
        return /*#__PURE__*/ React.createElement(MobileDevPageDisplaySide300x250Gak, {
            safety: safety
        });
    }
    return /*#__PURE__*/ React.createElement(MobileDevPageDisplaySide300x250Nitro, {
        safety: safety
    });
};
MobileDevPageDisplaySide300x250.displayName = 'MobileDevPageDisplaySide300x250';
export default MobileDevPageDisplaySide300x250;
